import React from 'react';

/**
 * SafeIcon component for rendering icons safely
 * @param {Object} props - Component props
 * @param {React.ComponentType} props.icon - The icon component to render
 * @param {string} [props.className] - Additional CSS classes
 * @param {Object} [props.rest] - Additional props to pass to the icon
 * @returns {React.ReactElement} - Rendered icon component
 */
const SafeIcon = ({ icon: Icon, className = '', ...rest }) => {
  if (!Icon) {
    console.warn('SafeIcon: No icon component provided');
    return null;
  }

  return <Icon className={className} {...rest} />;
};

export default SafeIcon;